// extracted by mini-css-extract-plugin
module.exports = {"centered":"Stripe_centered__3o8St"};